export class MediaTrack {
    constructor(public readonly track: MediaStreamTrack, public readonly name: string) {}
}
